module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }